














































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList,getPageAPIs } from "@/common/util";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import {IdolGoodsOrderAPI} from "@/common/api/userManage/idolOnSaleGoodsOrderList";

import {
  transferUserLevel2ch
} from '@/common/config'

import { excuteDownloadExport2Excel } from "@/common/xlsx";
export const pageApiList = getPageAPIs(IdolGoodsOrderAPI);

const defaultForm = {
  order_no: "", // 订单编号
  allin_order_no: "", // 通联编号
  user_phone: '', // 用户手机号
  shop_name: "", // 店铺名称
  create_time: [], // 创建时间
};

// 订单状态 1未付款  2已付款 3申请退款 4已退款 5已取消 8异常订单
// const orderStatus2Ch: any = [
//   '',
//   '未付款',
//   '已付款',
//   '申请退款',
//   '已退款',
//   '已取消',
//   '',
//   '',
//   '异常订单'
// ]

@Component({
  filters: {
    getMemberTypeName(type: number) {
      return transferUserLevel2ch[type] || '未开通'
    },
    // getOrderStatusText(status: number): string {
    //   return orderStatus2Ch[status] || ''
    // }
  }
})
export default class IdolGoodsOrderList extends Vue {
  private orderApi: any;

  private deepLoopUtil: any;

  constructor() {
    super();
    this.orderApi = new IdolGoodsOrderAPI();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };
  }

  private form: any;

  private firstLoading: boolean = true;
  // private chooseTechnicianItem : any = null;

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  // private show: boolean = false;
  // 订单状态 1未付款  2已付款 3申请退款 4已退款
  // private sortTypeList: any[] = [
  //   {
  //     value: -1,
  //     label: "全部",
  //   },
  //   {
  //     label: "未付款",
  //     value: 1,
  //   },
  //   {
  //     label: "已付款",
  //     value: 2,
  //   },
  //   {
  //     label: "申请退款",
  //     value: 3,
  //   },
  //   {
  //     label: "已退款",
  //     value: 4,
  //   },
  //   {
  //     label: "已取消",
  //     value: 5,
  //   },
  //   {
  //     label: '异常订单',
  //     value: 8
  //   }
  // ];

  private activated(): void {
    this.getTable();
    
  }

  private getTable(): void {
    this.orderApi.getOrderTableList(
      this.getOrderTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        // totalCount: 0,
        // pageNo: 1,
        // pageSize: 10,
        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      },
      false
    );
  }

  private getOrderTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      order_no, // 订单编号
      allin_order_no, // 通联编号
      user_phone, // 用户手机号
      shop_name, // 店铺名称
     
      create_time, // 创建时间
    } = form || {};


    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};


    if (order_no) {
      outerParams.order_no = order_no;
    }
    
    if (allin_order_no) {
      outerParams.allin_order_no = allin_order_no;
    }

    if (user_phone) {
      outerParams.user_phone = user_phone;
    }

    if (shop_name) {
      outerParams.shop_name = shop_name
    }


    // if (technicianItem && technicianItem.id) {
    //   outerParams.artificerId = technicianItem.id;
    // }

    if (Array.isArray(create_time) && create_time.length === 2) {
      const [startDate, endDate] = create_time;

      const startTime = Util.dateTimeUtilnohms(startDate);
      const endTime = Util.dateTimeUtilnohms(endDate);

      outerParams.created_start_time = startTime;

      outerParams.created_end_time = endTime;
    }


    if (
      mode == "exportExcel" &&
      !(outerParams.created_start_time && outerParams.created_end_time)
    ) {
      this.$message.error("请选择创建时段导出数据");
      return null;
    }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  private getOrderTotalMins(row: any) {
    const { daytime_minute, night_minute } = row || {};

    function tranformMinNums(mins: any) {
      return isNaN(Number(mins)) ? 0 : Number(mins);
    }

    return tranformMinNums(daytime_minute) + tranformMinNums(night_minute);
  }


  private getOrderSpendMoney(row: any) {
    const { price, refunded_price } = row;

    return (price - refunded_price).toFixed(2);
  }

  

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    // const { device, pay_type, user_type } = data;
    const newData = {
      ...data,
      // device_name: orderDeviceType2ch[device],
      // pay_type_name: payType2ch[pay_type],
      // user_level_type_name: userLevel2ch[user_type],
    };

    return newData;
  }


  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 订单字段名 文案对应关系
  private orderExcelList2ch: any = {
    order_no: "订单编号",
    allin_order_no: "通联编号",
    created_at: "创建时间",
    pay_time: "付款时间",
    user_name: "用户昵称",
    user_id: "用户ID",
    user_phone: "用户手机号",
    shop_id: "店铺ID",
    shop_name: "店铺名称",
    pool_name: "包厢名称",
    __good_details: "商品信息",
   
    price: "总价（元）",
    pay_type_name: "支付方式",
    __refund_goods_details: "退款商品",
    merchant_income: "商家收益",
   
  };
  // 订单Excel 表头的先后顺序
  private orderExcelSortList: string[] = [
    "order_no",
    "allin_order_no",
    "created_at",
    "pay_time",
    "user_name",
    "user_id",
    "user_phone",
    "shop_id",
    "shop_name",
    "pool_name",
    "__good_details",
  
    "price",
    "pay_type_name",
    "__refund_goods_details",
    "merchant_income",

  ];

  // 点击导出excel 表格
  private handleDownloadExcel() {
    const params = this.getOrderTableListParams("exportExcel");

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.orderApi.exportExcelOrderList(
      params,
      (res: any) => {
        const {
          created_start_time,
          created_end_time,
   
        } = params || {};

        const filename = `大明星商品点单列表 ${created_start_time}到${created_end_time}.xlsx`;
        const { data } = res || {};

        const { list: originList } = data || {};

        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              const {
                goods_list,
                refund_goods,
                // member_type,
                // product_discount,
                // status
              } = item || {};

              const newItem = {
                ...(item || {}),
                
                // __status_name: orderStatus2Ch[status],
                __good_details: goods_list.map((goods: any, index: number) => `${index + 1}、${ goods.name }x${ goods.num }  ¥${ goods.price }`).join('; \t'),

                __refund_goods_details: refund_goods.map((goods: any, index: number) => `${index + 1}、${ goods.name }x${ goods.num }  ¥${ goods.price }`).join('; \t'),

                // __member_type_name: transferUserLevel2ch[member_type] || '未开通',
                // __member_discount: parseFloat((product_discount / 10).toFixed(1))
              };

              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const orderExcelSortList = this.orderExcelSortList;

          const orderExcelList2ch = this.orderExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            orderExcelSortList,
            orderExcelList2ch
          );

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("选中时段没有可导出的信息");
        }

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */

  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm),
    };
    // this.form = new Util().clearObject(this.form);
    // this.$router.replace("/orderList");
    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
